import { useEffect, useState } from "react";
import { TabbedForm } from "../../lib/iprs-react-library/src"
import TabbedReportForm from "./TabbedReportForm";

const LegacyReportTabbedReportForm = ({ api }) => {

    const urlParams = new URLSearchParams(window.location.search);
    const caseID = urlParams.get('CaseID');
    const reportID = urlParams.get('ReportID');

    const [reportGUID, setReportGUID] = useState(null);

    useEffect(() => {

        api.webAPIFetch(`/api/PatientCaseReports/case/${caseID}`)
            .then(response => response.json())
            .then(data => {
                if (data && data.length > 0) {
                    const matchingReport = data.find(report => report.reportId === parseInt(reportID, 10));
                    if (matchingReport) {
                        setReportGUID(matchingReport.guid);
                    } else {
                        console.warn('No matching report found for the given CaseID.');
                    }
                } else {
                    console.warn('No data returned from the API for the given ReportID.');
                }
            })
            .catch(error => {
                console.error('Error fetching legacy report data:', error);
            });
    }, [caseID, reportID, api]);

    return <TabbedReportForm
                            reportId={reportGUID}
                            reportIntId={parseInt(reportID, 10)}
                            caseId={parseInt(caseID, 10)}
                            api={api}
                        />
}

export default LegacyReportTabbedReportForm;